import { ClaudeLogo } from '@/components/BrandAvatar';

interface IProps {
  role: 'user' | 'claude';
  text: string;
}

const ChatRow = ({ role, text }: IProps) => (
  <div className={`chat-row chat-row--${role}`}>
    {role === 'claude' && (
      <div className="claude-avatar-small" aria-hidden="true">{ClaudeLogo}</div>
    )}
    <div className={`chat-bubble chat-bubble--${role}`}>{text}</div>
  </div>
);

export default ChatRow;
